import type { EmailDownloadModel } from '@/models/EmailDownload/Model'
import EmailDownloadsApi from '@/models/EmailDownload/Api'
import DetailsState from '@/helpers/models/DetailsState'
import ListState from '@/helpers/models/ListState'
import type { LaravelPaginationResponse } from '@/interfaces/models/Laravel'

export class EmailDownloadDetailsState extends DetailsState<EmailDownloadsApi, EmailDownloadModel> {
	api = new EmailDownloadsApi()
}

export function useEmailDownloadDetailsState() {
	return new EmailDownloadDetailsState()
}

export class EmailDownloadListState extends ListState<
	EmailDownloadsApi,
	EmailDownloadModel,
	LaravelPaginationResponse<EmailDownloadModel>
> {
	api = new EmailDownloadsApi()
}

export function useEmailDownloadListState() {
	return new EmailDownloadListState()
}
